import { Component , OnInit } from '@angular/core';
 
@Component ({ 
    templateUrl : './privacy-policy.html',
   styleUrls: ['./privacy-policy.css']
})

export class PrivacyPolicyComponent  {

    constructor() { }

    ngOnInit() {
    }

}
  